import type { RunState } from "@zworks/console-contracts";
import { StatusBadge } from "./status-badge";

/** A labelled run-state badge shared by Runs, Run detail, and Work items. */
export function RunStateBadge({ state }: { state: RunState }) {
  return <StatusBadge kind="run" status={state} />;
}
